export default {
  "content": "<g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\"/><path fill=\"#3F4450\" fill-rule=\"nonzero\" d=\"M14.595 12.5h-.069c-.62-.328-1.675-4.184-2.32-8.505A4.488 4.488 0 007.813.5c-2.159 0-4.02 1.538-4.434 3.7-.433 4.216-1.31 8.02-1.879 8.3h-.097a.5.5 0 000 1h4.148c.232 1.14 1.242 2 2.449 2 1.207 0 2.217-.86 2.45-2h4.145a.5.5 0 000-1zM8 14.5c-.651 0-1.201-.42-1.408-1h2.816c-.207.58-.757 1-1.408 1zm-5.354-2c.881-1.668 1.413-5.136 1.721-8.154A3.514 3.514 0 017.813 1.5c1.643 0 3.049 1.119 3.411 2.68.461 3.1 1.161 6.633 2.111 8.32H2.646z\"/></g>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  }
};